__turbopack_context__.v({
  "active": "DropdownSection-module__wGOg8q__active",
  "blok-big-title": "DropdownSection-module__wGOg8q__blok-big-title",
  "blok-subtitle": "DropdownSection-module__wGOg8q__blok-subtitle",
  "blok-title": "DropdownSection-module__wGOg8q__blok-title",
  "checkbox": "DropdownSection-module__wGOg8q__checkbox",
  "child-checked": "DropdownSection-module__wGOg8q__child-checked",
  "controller": "DropdownSection-module__wGOg8q__controller",
  "filterNumber": "DropdownSection-module__wGOg8q__filterNumber",
  "group": "DropdownSection-module__wGOg8q__group",
  "has-child": "DropdownSection-module__wGOg8q__has-child",
  "header": "DropdownSection-module__wGOg8q__header",
  "input": "DropdownSection-module__wGOg8q__input",
  "label": "DropdownSection-module__wGOg8q__label",
  "minus": "DropdownSection-module__wGOg8q__minus",
  "plus": "DropdownSection-module__wGOg8q__plus",
  "root": "DropdownSection-module__wGOg8q__root",
  "showMoreBtn": "DropdownSection-module__wGOg8q__showMoreBtn",
  "title": "DropdownSection-module__wGOg8q__title",
});
